import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import PageHero from '../components/PageHero'

const OPTIONS = [
  {
    icon: 'bi-mortarboard-fill',
    title: 'Become a School Coordinator',
    text: 'Teachers and educators can join our network of School Coordinators, bringing structured football and education programs directly to students within their schools.',
    cta: 'Apply Now',
    href: '/apply',
    highlight: false,
  },
  {
    icon: 'bi-person-raised-hand',
    title: 'Volunteer',
    text: 'Share your time, skills, or expertise to support football training, education programs, and mentorship for children.',
    cta: 'Become a Volunteer',
    href: '/contact',
    highlight: false,
  },
  {
    icon: 'bi-building',
    title: 'Partner With Us',
    text: 'Schools, organisations, and institutions can collaborate with SISDI to expand access to structured football and education programs.',
    cta: 'Partner With SISDI',
    href: '/contact',
    highlight: false,
  },
  {
    icon: 'bi-trophy-fill',
    title: 'Sponsor a Program',
    text: 'Sponsors help fund training equipment, school programs, and long-term development initiatives across communities.',
    cta: 'Sponsor a Program',
    href: '/donate',
    highlight: true,
  },
]

export default function GetInvolved() {
  return (
    <>
      <Navbar />
      <PageHero
        title="Get Involved"
        subtitle="Your involvement helps us provide children across Africa with access to football, education, and life-changing opportunities."
        variant="involved"
        fadeClass="fade-in"
      />

      <main>
        {/* Options */}
        <section className="section fade-in">
          <div className="container">
            <div className="section-header">
              <span className="eyebrow">Ways to Help</span>
              <h2>How You Can <span className="text-accent">Make a Difference</span></h2>
              <div className="section-divider"></div>
            </div>

            <div className="grid-2 fade-in fade-in-stagger" style={{ marginTop: '3rem' }}>
              {OPTIONS.map((o, i) => (
                <div className={`involve-card${o.highlight ? ' highlight' : ''}`} key={i}>
                  <div
                    className="icon-circle"
                    style={o.highlight ? { background: 'var(--color-accent)', color: 'var(--color-dark)' } : {}}
                  >
                    <i className={`bi ${o.icon}`}></i>
                  </div>
                  <h4>{o.title}</h4>
                  <p>{o.text}</p>
                  <a
                    href={o.href}
                    className={`btn ${o.highlight ? 'btn-accent' : 'btn-secondary'}`}
                    style={{ marginTop: '1.5rem' }}
                  >
                    {o.cta}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Every Contribution CTA */}
        <section className="section bg-light text-center fade-in">
          <div className="container">
            <span className="eyebrow">Your Impact</span>
            <h2 style={{ marginTop: '0.5rem', marginBottom: '1rem' }}>
              Every Contribution <span className="text-accent">Matters</span>
            </h2>
            <p style={{ maxWidth: '580px', margin: '0 auto 2rem' }}>
              Whether you volunteer, partner, or sponsor, your involvement directly
              impacts the lives of children both on and off the pitch.
            </p>
            <a href="/donate" className="btn btn-accent btn-lg">
              <i className="bi bi-heart-fill"></i> Support SISDI
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  )
}
